/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import { Container, Row, Col } from 'react-grid-system'

import Logo from '../svg/Logo'
import { mq } from '../../theme'

const PublicViewsHeader: React.FC = () => {
  return (
    <div css={{ backgroundColor: 'white', padding: '1em 0px' }}>
      <Container>
        <Row>
          <Col>
            <div
              css={[
                mq('d-flex'),
                mq('', 'xs', {
                  justifyContent: 'center',
                  alignItems: 'center',
                }),
              ]}
            >
              <div css={[mq('text-center'), mq('', 'xs', { width: '98px' })]}>
                <Logo width="100%" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PublicViewsHeader
